/*
 *  Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import ControlledAccordionSchufa from "./ControlledAccordionSchufa";
import Typography from "@mui/material/Typography";
import TextContainer from "../../../../../../components/Container/TextContainer";
import { scrollToAnchor } from "../../../../../../theme/commonStyle";
import { Box } from "@mui/material";
import { AccordionContent } from "../../../../../../types/AccordionContent";

export interface ControlledAccordionSectionSchufaProps {
  contentList: AccordionContent[];
  heading: string;
  idPrefix: string;
  name: string;
}

export default function ControlledAccordionSectionSchufa({ contentList, idPrefix, name, heading }: ControlledAccordionSectionSchufaProps) {
  return (
    <TextContainer>
      <Box sx={scrollToAnchor} id={idPrefix + "-accordion"} />
      <Typography variant={"h2"} textAlign={"center"} marginBottom={"3rem"}>
        {heading}
      </Typography>
      <ControlledAccordionSchufa contentList={contentList} idPrefix={idPrefix} name={name} />
    </TextContainer>
  );
}
